import PropTypes from 'prop-types';
import React from 'react';

import { Search } from 'lucide-react';
import Moment from 'moment-timezone';
import { ButtonIcon, DefaultTable } from 'twyne-new.ui';

import AuditResultDetails from './AuditResultDetails';

const propTypes = {
  impressions: PropTypes.array,
}

const formatDateTime = cell => Moment(cell).format('MMM DD, YYYY - hh:mm A');
const formatSite = cell => cell.name;
const formatPath = cell => cell.name;
const formatPage = cell => cell.name;
const formatPid = cell => cell.pid;
const formatSlotPosition = cell => cell.slot_position;

class AuditResultTable extends React.Component {
  state = {
    request: null,
  }

  requestDetailsToggle = () => {
    this.setState({ request: null });
  }

  actions = (cell, row) => <ButtonIcon content='Details' onClick={() => this.setState({ request: row.request })}>
    <Search size='16' />
  </ButtonIcon>

  render() {
    const { impressions } = this.props;
    const columns = [
      { isKey: true, dataFormat: formatDateTime, dataField: '@timestamp', text: 'DateTime', formatter: formatDateTime },
      { dataFormat: formatSite, dataField: 'site', text: 'Site', formatter: formatSite },
      { dataFormat: formatPath, dataField: 'path', text: 'Path', formatter: formatPath },
      { dataFormat: formatPage, dataField: 'page', text: 'Page', formatter: formatPage },
      { dataFormat: formatPid, dataField: 'request', text: 'PID', formatter: formatPid },
      { dataFormat: formatSlotPosition, dataField: 'request', text: 'Slot Position', formatter: formatSlotPosition },
      { dataField: '', className: 'w-8', formatter: this.actions },
    ]
    return (
      <div className="overflow-y-auto max-h-[30vh]">
        <DefaultTable
          keyField='@timestamp'
          columns={columns}
          data={impressions}
        />
        <AuditResultDetails request={this.state.request} toggle={this.requestDetailsToggle} />
      </div>
    );
  }
}

AuditResultTable.propTypes = propTypes;

export default AuditResultTable;
